export default{
	//sessionStorage//存储
	save_data(name,obj){
		if(name!=undefined){
			let str=this.utf8_to_b64(JSON.stringify(obj));
				str=str+"xunWNmlinBwyxhgNYmhk";
				str=str.replace(/\s+/g,"");
			sessionStorage.setItem(name,str);
		}else{
			return this.utf8_to_b64(JSON.stringify(obj))
		}
	},
	get_data(name){
		var data=sessionStorage.getItem(name)
			if(data==null){
				return null
			}else{
				data=data.slice(0,-20)
			 	data=this.b64_to_utf8(data)
			 	data=JSON.parse(data)
			}
		return  data
	},
	remove_data(name){
		var data=sessionStorage.getItem(name)
			if(data==null){
				return null
			}else{
				sessionStorage.removeItem(name)
			}
	},
	//localStorage存储
	saveData(name,obj){
		if(name!=undefined){
			let str=this.utf8_to_b64(JSON.stringify(obj));
				str=str+"xunWNmlinBwyxhgNYmhk";
			localStorage.setItem(name,str);
		}else{
			return this.utf8_to_b64(JSON.stringify(obj))
		}
	},
	getData(name){
		var data=localStorage.getItem(name)
			if(data==null){
				return null
			}else{
				data=data.slice(0,-20)
			 	data=this.b64_to_utf8(data)
			 	data=JSON.parse(data)
			}


		return  data
	},
	removeData(name){
		var data=localStorage.getItem(name)
			if(data==null){
				return null
			}else{
				localStorage.removeItem(name)
			}
	},

	// str=str.replace(/\s+/g,"");
	utf8_to_b64( str ) {
		return window.btoa(escape(encodeURIComponent( str )));
		// return window.btoa(encodeURIComponent( str ));
	},
	b64_to_utf8( str ) {
	    // return decodeURIComponent(window.atob( str ));
	    return decodeURIComponent(unescape(window.atob( str )));
	},
//	权限判定
  /****
   * 权限状态
   * p 项目
   * c 公司
   ******/
	jur(str,pos){
		let arr,arrC;
		if(pos=='c'){
			arr=this.get_data('enterprisePermissions')||''
			if(arr.indexOf(str)!=-1||arr.indexOf('company.*')!=-1){
				return true
			}else{
				return false
			}
		}
		if(pos=='p' && str.substring(0,7) == 'project'){
			arr=this.get_data('initialProjectPermission')||''
			arrC=this.get_data('enterprisePermissions')||''
			if(arr.indexOf(str)!=-1||arrC.indexOf('company.*')!=-1||arr.indexOf('project.*')!=-1||arrC.indexOf('company.project.building.all')!=-1){
			// if(arr.indexOf(str)!=-1||arr.indexOf('project.*')!=-1){
				return true
			}else{
				return false
			}
		}

	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Self-madeLibrary/userData.js